import * as M from '@mantine/core';
import { handleChangeLocaleTime } from '../../../../../../../shared/utils/time';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import HoverCardText from '../../../../../../ui/hoverCardText';
import { IconDotsVertical } from '@tabler/icons-react';
import useDeleteTemplate from '../hooks/useDeleteTemplate';
import Swal from 'sweetalert2';
import { buildSearchString } from '../../../utils/buildSearchString';
import { ApiResponse } from '../../../../../../../shared/types/response/types';
import { IAsCsTemplate } from '../../../../../../../shared/apis/ai-agent/template/types';

interface TemplateListTableProps {
  onOpen: (templateId: number, headerIndex: number) => void;
  data?: ApiResponse<IAsCsTemplate>;
}

export default function TemplateListTable(props: TemplateListTableProps) {
  const { onOpen, data } = props;
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';
  const { mutate: deleteTemplate } = useDeleteTemplate();
  const onClickDeleteTemplate = (templateId: number) => {
    Swal.fire({
      title: '템플릿 삭제',
      text: '템플릿을 삭제하시겠습니까?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteTemplate(templateId);
      }
    });
  };
  return (
    <M.Box>
      <M.Group justify="space-between" mb="md" align="flex-end">
        <M.Text fw={600}>AS/CS 템플릿 목록</M.Text>
        <M.Button
          color="secondary"
          onClick={() =>
            navigate(`/admin/management/aiagent/company/${companyId}/template/register${buildSearchString({ companyName })}`)
          }
        >
          템플릿 등록
        </M.Button>
      </M.Group>
      <M.Table.ScrollContainer minWidth={1000}>
        <M.Table>
          <M.Table.Thead>
            <M.Table.Tr>
              <M.Table.Th>번호</M.Table.Th>
              <M.Table.Th>템플릿명</M.Table.Th>
              <M.Table.Th>상세 설명</M.Table.Th>
              <M.Table.Th>참조 문서 Header 열 번호</M.Table.Th>
              <M.Table.Th>등록 담당자</M.Table.Th>
              <M.Table.Th>등록일시</M.Table.Th>
              <M.Table.Th>삭제 담당자</M.Table.Th>
              <M.Table.Th>삭제일시</M.Table.Th>
              <M.Table.Th>관리</M.Table.Th>
            </M.Table.Tr>
          </M.Table.Thead>
          <M.Table.Tbody>
            {data && data.result.length > 0 ? (
              data?.result?.map((item, index) => (
                <M.Table.Tr
                  key={item.id}
                  style={(theme) => ({
                    color: item.deleteDt ? theme.colors.gray[5] : 'inherit',
                  })}
                >
                  <M.Table.Td>{item.id}</M.Table.Td>
                  <M.Table.Td
                    ta="left"
                    miw={180}
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() => onOpen(item.id, item.headerIndex)}
                  >
                    {item.name}
                  </M.Table.Td>
                  <M.Table.Td ta="left" maw={240}>
                    <HoverCardText value={item.description} />
                  </M.Table.Td>
                  <M.Table.Td>{item.headerIndex}</M.Table.Td>
                  <M.Table.Td ta="left">{item.regUserEmail}</M.Table.Td>
                  <M.Table.Td>{handleChangeLocaleTime(item.regDt)}</M.Table.Td>
                  <M.Table.Td ta="left">{item.deleteUserEmail}</M.Table.Td>
                  <M.Table.Td>{handleChangeLocaleTime(item.deleteDt)}</M.Table.Td>
                  <M.Table.Td>
                    <M.Menu>
                      <M.Menu.Target>
                        <M.ActionIcon variant="default">
                          <IconDotsVertical size={16} />
                        </M.ActionIcon>
                      </M.Menu.Target>
                      <M.Menu.Dropdown>
                        <M.Menu.Item
                          disabled={!!item.deleteDt}
                          onClick={() => {
                            onClickDeleteTemplate(item.id);
                          }}
                        >
                          삭제
                        </M.Menu.Item>
                      </M.Menu.Dropdown>
                    </M.Menu>
                  </M.Table.Td>
                </M.Table.Tr>
              ))
            ) : (
              <M.Table.Tr>
                <M.Table.Td colSpan={9}>
                  <M.Text ta="center" size="sm">
                    등록된 템플릿이 없습니다.
                  </M.Text>
                </M.Table.Td>
              </M.Table.Tr>
            )}
          </M.Table.Tbody>
        </M.Table>
      </M.Table.ScrollContainer>
      <M.Group justify="center" mt="md">
        <M.Pagination total={Math.ceil((data?.count || 0) / 10)} value={1} />
      </M.Group>
    </M.Box>
  );
}
